import Tr from 'translations/Translations';
import {createSelectItem} from "../components/Select";

export const ContractorDocumentType = {
    PUBLIC: "PUBLIC",
    SECRET: "SECRET",
    RODO: "RODO"
}

export const ContractorDocumentTypeSelectItems = (curVal) => Object.values(ContractorDocumentType)
    .filter((type) => type !== ContractorDocumentType.RODO || curVal === ContractorDocumentType.RODO).map(x => createSelectItem(x, ContractorDocumentTypeLabel(x)));


const _TR_PREFIX = 'contractor_document_type_';
export const ContractorDocumentTypeLabel = (type) => (Tr(_TR_PREFIX + type.toLowerCase()));
